/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%]{color:#ff720a;text-align:center}[text-align-center][_ngcontent-%COMP%]{text-align:center}.custom-button[_ngcontent-%COMP%]{border-radius:20px;width:120px}.icon[_ngcontent-%COMP%]{width:50px;height:50px;display:-webkit-box;display:flex;background-size:contain!important;background-repeat:no-repeat!important;background-position:center center!important;-webkit-box-pack:center;justify-content:center;margin:auto}"];
export { styles as styles };
